import type { Api } from "@/api";
import { type B2cBrand, CarBrandsListDocument } from "@/generated/graphql.lazy/b2c";

export class Brands {
  brands = new Map<string, B2cBrand>();

  constructor(protected api: Api) {}

  async load() {
    const brandsRespose = await this.api.client.query({
      query: CarBrandsListDocument,
      variables: {},
    });

    this.setPreloadedBrands(brandsRespose.data.CarBrandsList as B2cBrand[]);
  }

  setPreloadedBrands(brands: B2cBrand[]) {
    this.brands.clear();
    for (const brand of brands) {
      this.brands.set(brand.id, brand);
    }
  }

  clear() {
    this.brands.clear();
  }

  get list() {
    return Array.from(this.brands.values());
  }

  getItem(id: string) {
    return this.brands.get(id)!;
  }
}
